import moment from "moment";

import { quoteStatusColor, quoteStatusTitle } from "types/enums";
import { formatPrice } from "utils/formats";

import { RedeTransaction } from "../../aggregate";
import * as S from "../../styles";

interface RedeTransactionsTableProps {
  rows: RedeTransaction[];
  isLoading: boolean;
  isTruncated: boolean;
}

export default function RedeTransactionsTable({
  rows,
  isLoading,
  isTruncated,
}: RedeTransactionsTableProps) {
  return (
    <div className="card p-0 overflow-hidden">
      <div className="card-header border-bottom d-flex align-items-center gap-2 py-3 px-3">
        <i className="uil uil-bill text-primary fs-5" aria-hidden="true"></i>
        <span className="fw-bold">Valores transacionados e repassados</span>
      </div>

      {isTruncated && (
        <div className="alert alert-warning mb-0 d-flex align-items-center gap-2 rounded-0">
          <i className="uil uil-exclamation-triangle fs-5 flex-shrink-0" aria-hidden="true"></i>
          <span>
            Mostrando apenas as <strong>500 transações</strong> mais recentes do
            período. Restrinja o filtro de data para ver tudo.
          </span>
        </div>
      )}

      {isLoading ? (
        <div className="p-3 d-flex flex-column gap-3" aria-label="Carregando transações">
          {[...Array(6)].map((_, i) => (
            <S.Skeleton key={i} height="1.25rem" />
          ))}
        </div>
      ) : rows.length > 0 ? (
        <div className="table-responsive">
          <table className="table table-hover mb-0 small align-middle">
            <thead className="table-light">
              <tr>
                <th className="ps-3">Data</th>
                <th>Paciente</th>
                <th>Médico</th>
                <th className="text-end">Transacionado</th>
                <th className="text-end">Repassado</th>
                <th className="pe-3">Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((t) => (
                <tr key={t.id}>
                  <td className="ps-3">
                    {t.date ? moment(t.date).format("DD/MM/YYYY") : "—"}
                  </td>
                  <td style={{ maxWidth: 180 }}>
                    <span className="d-block text-truncate" title={t.patientName}>
                      {t.patientName}
                    </span>
                  </td>
                  <td style={{ maxWidth: 180 }}>
                    <span className="d-block text-truncate" title={t.professionalName}>
                      {t.professionalName}
                    </span>
                  </td>
                  <td className="text-end fw-bold text-success">
                    {formatPrice(t.transacionado)}
                  </td>
                  <td className="text-end fw-bold text-primary">
                    {formatPrice(t.repassado)}
                  </td>
                  <td className="pe-3">
                    <span className={`badge bg-${quoteStatusColor.get(t.status)}`}>
                      {quoteStatusTitle.get(t.status)}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-muted text-center py-5">
          <i className="uil uil-bill display-4 d-block mb-2 opacity-25" aria-hidden="true"></i>
          <small className="d-block">Nenhuma transação no período selecionado.</small>
          <small>Tente ampliar o período ou remover os filtros.</small>
        </div>
      )}
    </div>
  );
}
